/**
 * CJSUSPENSION theme helpers.
 */

/* CJSUSPENSION product deep links
 * Model/service pages can add one or more ?cjs_select=Option%20Value parameters
 * to a product URL. This helper selects matching product option values by their
 * visible label/value, so links can open the correct fork/model option without
 * hard-coding Shopify variant IDs.
 *
 * For older model-page links that do not yet have cjs_select parameters, a small
 * set of unambiguous referrer rules is also used. Ambiguous choices such as
 * Lyrik/Yari generation, BoXXer chassis generation or spring rate are never
 * guessed.
 */
(function () {
  'use strict';

  var params = new URLSearchParams(window.location.search);
  var requestedValues = params.getAll('cjs_select').filter(Boolean);

  function addReferrerDefaults() {
    var referrer = document.referrer || '';
    var path = window.location.pathname || '';

    if (referrer.indexOf('/pages/rockshox-zeb') !== -1) {
      if (path.indexOf('/products/vorsprung-rockshox-luftkappe-kits') !== -1) {
        requestedValues.push('Zeb');
      }

      if (path.indexOf('/products/rockshox-smashpot-fork-coil-conversion-system') !== -1) {
        requestedValues.push('Zeb 2021+ A1+, Domain 2021+ B1+');
      }
    }

    if (referrer.indexOf('/pages/rockshox-domain') !== -1) {
      if (path.indexOf('/products/vorsprung-rockshox-luftkappe-kits') !== -1) {
        requestedValues.push('Domain');
      }

      if (path.indexOf('/products/rockshox-smashpot-fork-coil-conversion-system') !== -1) {
        requestedValues.push('Zeb 2021+ A1+, Domain 2021+ B1+');
      }
    }
  }

  if (!requestedValues.length) {
    addReferrerDefaults();
  }

  if (!requestedValues.length) {
    return;
  }

  function normalise(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  var pending = requestedValues.map(function (value) {
    return {
      normalised: normalise(value),
      done: false
    };
  });

  function dispatchChange(element) {
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function selectRequestedValue(item) {
    var target = item.normalised;
    var i;
    var j;

    var selects = document.querySelectorAll('select');
    for (i = 0; i < selects.length; i++) {
      var select = selects[i];
      var options = select.options || [];

      for (j = 0; j < options.length; j++) {
        var option = options[j];
        if (normalise(option.textContent) === target || normalise(option.value) === target) {
          if (select.value !== option.value) {
            select.value = option.value;
            dispatchChange(select);
          }
          item.done = true;
          return true;
        }
      }
    }

    var radios = document.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    for (i = 0; i < radios.length; i++) {
      var input = radios[i];
      if (normalise(input.value) === target) {
        if (!input.checked) {
          input.click();
          dispatchChange(input);
        }
        item.done = true;
        return true;
      }
    }

    var labels = document.querySelectorAll('label');
    for (i = 0; i < labels.length; i++) {
      if (normalise(labels[i].textContent) === target) {
        labels[i].click();
        item.done = true;
        return true;
      }
    }

    var dataValueElements = document.querySelectorAll('[data-value]');
    for (i = 0; i < dataValueElements.length; i++) {
      if (normalise(dataValueElements[i].getAttribute('data-value')) === target) {
        dataValueElements[i].click();
        item.done = true;
        return true;
      }
    }

    var buttons = document.querySelectorAll('button');
    for (i = 0; i < buttons.length; i++) {
      if (normalise(buttons[i].textContent) === target) {
        buttons[i].click();
        item.done = true;
        return true;
      }
    }

    return false;
  }

  var attempts = 0;
  var maxAttempts = 30;
  var timer = window.setInterval(function () {
    attempts += 1;

    pending.forEach(function (item) {
      if (!item.done) {
        selectRequestedValue(item);
      }
    });

    var complete = pending.every(function (item) {
      return item.done;
    });

    if (complete || attempts >= maxAttempts) {
      window.clearInterval(timer);
    }
  }, 150);
})();

/* CJSUSPENSION model page links
 * Connects Brands We Service model pills, the desktop brands mega menu and
 * supported brand-page cards to the dedicated model-page handles.
 * Models without a dedicated page remain normal text or keep their existing link.
 */
(function () {
  'use strict';

  function normalise(value) {
    return String(value || '')
      .replace(/&amp;/gi, '&')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  var brandPrefixes = {
    fox: ['fox '],
    rockshox: ['rockshox '],
    ohlins: ['öhlins ', 'ohlins '],
    marzocchi: ['marzocchi '],
    dvo: ['dvo '],
    canecreek: ['cane creek ']
  };

  function stripBrand(value, brand) {
    var text = normalise(value);
    var prefixes = brandPrefixes[brand] || [];

    prefixes.some(function (prefix) {
      if (text.indexOf(prefix) === 0) {
        text = text.slice(prefix.length);
        return true;
      }
      return false;
    });

    return text;
  }

  var modelUrls = {
    fox: {
      '32': '/pages/fox-32',
      '34': '/pages/fox-34',
      '34 sl': '/pages/fox-34',
      '36': '/pages/fox-36',
      '36 sl': '/pages/fox-36',
      '38': '/pages/fox-38',
      '40': '/pages/fox-40',
      'podium': '/pages/fox-podium',
      '831': '/pages/fox-831',
      'brain shock': '/pages/fox-brain-shock',
      'float': '/pages/fox-float',
      'float sl': '/pages/fox-float-sl',
      'float dps': '/pages/fox-float-dps',
      'dps': '/pages/fox-float-dps',
      'dpx2': '/pages/fox-dpx2',
      'float dpx2': '/pages/fox-dpx2',
      'float ctd': '/pages/fox-float-ctd',
      'ctd': '/pages/fox-float-ctd',
      'float rp23': '/pages/fox-float-rp-series',
      'rp23': '/pages/fox-float-rp-series',
      'float rp-series': '/pages/fox-float-rp-series',
      'float x': '/pages/fox-float-x',
      'float x ctd': '/pages/fox-float-x-ctd',
      'float x2': '/pages/fox-float-x2',
      'dhx': '/pages/fox-dhx',
      'dhx2': '/pages/fox-dhx2',
      'dhx rc4': '/pages/fox-dhx-rc4-rc2',
      'dhx rc4 / rc2': '/pages/fox-dhx-rc4-rc2',
      'dhx air 5.0 / 4.0 / 3.0': '/pages/fox-dhx-air-5-0-4-0-3-0',
      'dhx coil 5.0 / 4.0 / 3.0': '/pages/fox-dhx-coil-5-0-4-0-3-0',
      'van r': '/pages/fox-van-r-rc',
      'van rc': '/pages/fox-van-r-rc',
      'van r / rc': '/pages/fox-van-r-rc',
      'vanilla': '/pages/fox-vanilla',
      'specialized genie': '/pages/fox-specialized-genie',
      'transfer': '/pages/fox-transfer'
    },
    rockshox: {
      'sid sl': '/pages/rockshox-sid-sl',
      'sid': '/pages/rockshox-sid',
      'pike': '/pages/rockshox-pike',
      'lyrik': '/pages/rockshox-lyrik',
      'zeb': '/pages/rockshox-zeb',
      'boxxer': '/pages/rockshox-boxxer',
      'domain': '/pages/rockshox-domain',
      'yari': '/pages/rockshox-yari',
      'revelation': '/pages/rockshox-revelation',
      'sektor': '/pages/rockshox-sektor',
      'recon': '/pages/rockshox-recon',
      'judy': '/pages/rockshox-judy',
      'reba': '/pages/rockshox-reba',
      '35': '/pages/rockshox-35',
      '30': '/pages/rockshox-30',
      'xc': '/pages/rockshox-xc-series',
      'xc-series': '/pages/rockshox-xc-series',
      'bluto': '/pages/rockshox-bluto',
      'psylo': '/pages/rockshox-psylo',
      'rs-1': '/pages/rockshox-rs-1',
      'sidluxe': '/pages/rockshox-sidluxe',
      'deluxe': '/pages/rockshox-deluxe',
      'deluxe coil': '/pages/rockshox-deluxe-coil',
      'super deluxe': '/pages/rockshox-super-deluxe',
      'super deluxe air': '/pages/rockshox-super-deluxe',
      'super deluxe coil': '/pages/rockshox-super-deluxe-coil',
      'vivid air': '/pages/rockshox-vivid-air',
      'vivid coil': '/pages/rockshox-vivid-coil',
      'monarch': '/pages/rockshox-monarch',
      'monarch plus': '/pages/rockshox-monarch-plus',
      'kage': '/pages/rockshox-kage',
      'reverb': '/pages/rockshox-reverb',
      'reverb axs': '/pages/rockshox-reverb-axs',
      'brain shock': '/pages/rockshox-brain-shock'
    },
    ohlins: {
      'rxc34': '/pages/ohlins-rxc34',
      'rxf34': '/pages/ohlins-rxf34',
      'rxf36': '/pages/ohlins-rxf36',
      'rxf38': '/pages/ohlins-rxf38',
      'dh38': '/pages/ohlins-dh38',
      'rxfdj': '/pages/ohlins-rxfdj',
      'txc1air': '/pages/ohlins-txc1air',
      'txc2air': '/pages/ohlins-txc2air',
      'ttx1air': '/pages/ohlins-ttx1air',
      'ttx1air m.2': '/pages/ohlins-ttx1air',
      'ttx2air': '/pages/ohlins-ttx2air',
      'ttx2air m.2': '/pages/ohlins-ttx2air',
      'ttx22m': '/pages/ohlins-ttx22m',
      'ttx22m.2': '/pages/ohlins-ttx22m',
      'stx22 air': '/pages/ohlins-stx22-air'
    },
    marzocchi: {
      'bomber z1': '/pages/marzocchi-bomber-z1',
      'bomber z1 coil': '/pages/marzocchi-bomber-z1',
      'bomber z2': '/pages/marzocchi-bomber-z2',
      'bomber 58': '/pages/marzocchi-bomber-58',
      'bomber dj': '/pages/marzocchi-bomber-dj',
      'super z': '/pages/marzocchi-super-z',
      'bomber z': '/pages/marzocchi-bomber-z',
      '380': '/pages/marzocchi-380',
      '350': '/pages/marzocchi-350',
      '888': '/pages/marzocchi-888',
      '66': '/pages/marzocchi-66',
      '55': '/pages/marzocchi-55',
      'dirt jumper': '/pages/marzocchi-dirt-jumper',
      'bomber cr': '/pages/marzocchi-bomber-cr',
      'bomber air': '/pages/marzocchi-bomber-air',
      'bomber inline': '/pages/marzocchi-bomber-inline'
    },
    dvo: {
      'onyx 38': '/pages/dvo-onyx-38',
      'onyx sc': '/pages/dvo-onyx-sc',
      'onyx sc 36': '/pages/dvo-onyx-sc',
      'onyx dc': '/pages/dvo-onyx-dc',
      'diamond 35': '/pages/dvo-diamond',
      'diamond 36': '/pages/dvo-diamond',
      'sapphire 32': '/pages/dvo-sapphire',
      'sapphire 34': '/pages/dvo-sapphire',
      'emerald': '/pages/dvo-emerald',
      'beryl': '/pages/dvo-beryl',
      'topaz': '/pages/dvo-topaz',
      'topaz gen 3': '/pages/dvo-topaz-gen-3',
      'topaz prime': '/pages/dvo-topaz-gen-3',
      'jade': '/pages/dvo-jade',
      'jade x': '/pages/dvo-jade-x',
      'jade x prime': '/pages/dvo-jade-x',
      'opal': '/pages/dvo-opal'
    },
    canecreek: {
      'helm': '/pages/cane-creek-helm',
      'helm mkii': '/pages/cane-creek-helm-mkii',
      'air il': '/pages/cane-creek-air-il',
      'dbair il': '/pages/cane-creek-air-il',
      'dbinline': '/pages/cane-creek-air-il',
      'db air': '/pages/cane-creek-dbair',
      'db air il': '/pages/cane-creek-air-il',
      'coil il': '/pages/cane-creek-coil-il',
      'dbcoil il': '/pages/cane-creek-coil-il',
      'db coil': '/pages/cane-creek-dbcoil',
      'db coil il': '/pages/cane-creek-coil-il',
      'dbair': '/pages/cane-creek-dbair',
      'dbair cs': '/pages/cane-creek-dbair',
      'dbcoil': '/pages/cane-creek-dbcoil',
      'dbcoil cs': '/pages/cane-creek-dbcoil',
      'kitsuma air': '/pages/cane-creek-kitsuma-air',
      'kitsuma coil': '/pages/cane-creek-kitsuma-coil',
      'tigon': '/pages/cane-creek-tigon'
    }
  };

  var brandHubUrls = {
    fox: '/pages/fox-suspension-service',
    rockshox: '/pages/rockshox-suspension-service',
    ohlins: '/pages/ohlins-suspension-service',
    marzocchi: '/pages/marzocchi-suspension-service',
    dvo: '/pages/dvo-suspension-service',
    canecreek: '/pages/cane-creek-suspension-service'
  };

  var requiredHubModels = {
    fox: [
      { label: '831', url: '/pages/fox-831' },
      { label: 'Brain Shock', url: '/pages/fox-brain-shock' },
      { label: 'DHX Air 5.0 / 4.0 / 3.0', url: '/pages/fox-dhx-air-5-0-4-0-3-0' },
      { label: 'DHX Coil 5.0 / 4.0 / 3.0', url: '/pages/fox-dhx-coil-5-0-4-0-3-0' },
      { label: 'Float X CTD', url: '/pages/fox-float-x-ctd' },
      { label: 'Specialized GENIE', url: '/pages/fox-specialized-genie' },
      { label: 'Vanilla', url: '/pages/fox-vanilla' }
    ],
    rockshox: [
      { label: 'RS-1', url: '/pages/rockshox-rs-1' },
      { label: 'Reverb AXS', url: '/pages/rockshox-reverb-axs' },
      { label: 'Brain Shock', url: '/pages/rockshox-brain-shock' }
    ]
  };

  var megaMenuGroups = {
    fox: {
      '32 & 34': [
        { label: 'Fox 32', url: '/pages/fox-32' },
        { label: 'Fox 34', url: '/pages/fox-34' }
      ],
      'dhx & dhx2': [
        { label: 'Fox DHX', url: '/pages/fox-dhx' },
        { label: 'Fox DHX2', url: '/pages/fox-dhx2' }
      ]
    },
    rockshox: {
      'super deluxe': [
        { label: 'RockShox Super Deluxe Air', url: '/pages/rockshox-super-deluxe' },
        { label: 'RockShox Super Deluxe Coil', url: '/pages/rockshox-super-deluxe-coil' }
      ],
      'vivid': [
        { label: 'RockShox Vivid Air', url: '/pages/rockshox-vivid-air' },
        { label: 'RockShox Vivid Coil', url: '/pages/rockshox-vivid-coil' }
      ]
    },
    ohlins: {
      'ttx air': [
        { label: 'Öhlins TTX1Air', url: '/pages/ohlins-ttx1air' },
        { label: 'Öhlins TTX2Air', url: '/pages/ohlins-ttx2air' }
      ],
      'ttx coil & ttx22m': [
        { label: 'Öhlins TTX22M / TTX22M.2', url: '/pages/ohlins-ttx22m' }
      ]
    },
    marzocchi: {},
    dvo: {},
    canecreek: {}
  };

  var singleCardLinks = {
    'fox 38': { url: '/pages/fox-38', label: 'View Fox 38 Service' },
    'fox podium': { url: '/pages/fox-podium', label: 'View Fox Podium Service' },
    'fox 40': { url: '/pages/fox-40', label: 'View Fox 40 Service' },
    'fox float': { url: '/pages/fox-float', label: 'View Fox Float Service' },
    'fox float x2': { url: '/pages/fox-float-x2', label: 'View Fox Float X2 Service' },
    'fox transfer': { url: '/pages/fox-transfer', label: 'View Fox Transfer Service' },
    'rockshox sid': { url: '/pages/rockshox-sid', label: 'View RockShox SID Service' },
    'rockshox pike': { url: '/pages/rockshox-pike', label: 'View RockShox Pike Service' },
    'rockshox lyrik': { url: '/pages/rockshox-lyrik', label: 'View RockShox Lyrik Service' },
    'rockshox zeb': { url: '/pages/rockshox-zeb', label: 'View RockShox ZEB Service' },
    'rockshox boxxer': { url: '/pages/rockshox-boxxer', label: 'View RockShox BoXXer Service' },
    'rockshox deluxe': { url: '/pages/rockshox-deluxe', label: 'View RockShox Deluxe Service' },
    'rockshox reverb': { url: '/pages/rockshox-reverb', label: 'View RockShox Reverb Service' },
    'öhlins rxf34': { url: '/pages/ohlins-rxf34', label: 'View Öhlins RXF34 Service' },
    'öhlins rxf36': { url: '/pages/ohlins-rxf36', label: 'View Öhlins RXF36 Service' },
    'öhlins rxf38': { url: '/pages/ohlins-rxf38', label: 'View Öhlins RXF38 Service' },
    'öhlins dh38': { url: '/pages/ohlins-dh38', label: 'View Öhlins DH38 Service' },
    'marzocchi bomber z2': { url: '/pages/marzocchi-bomber-z2', label: 'View Bomber Z2 Service' },
    'marzocchi bomber z1': { url: '/pages/marzocchi-bomber-z1', label: 'View Bomber Z1 Service' },
    'marzocchi bomber z1 coil': { url: '/pages/marzocchi-bomber-z1', label: 'View Bomber Z1 Coil Service' },
    'marzocchi bomber 58': { url: '/pages/marzocchi-bomber-58', label: 'View Bomber 58 Service' },
    'marzocchi bomber air': { url: '/pages/marzocchi-bomber-air', label: 'View Bomber Air Service' },
    'marzocchi bomber cr': { url: '/pages/marzocchi-bomber-cr', label: 'View Bomber CR Service' },
    'cane creek kitsuma air': { url: '/pages/cane-creek-kitsuma-air', label: 'View Kitsuma Air Service' },
    'cane creek kitsuma coil': { url: '/pages/cane-creek-kitsuma-coil', label: 'View Kitsuma Coil Service' },
    'cane creek db air': { url: '/pages/cane-creek-dbair', label: 'View Cane Creek DBair Service' },
    'cane creek db air il': { url: '/pages/cane-creek-air-il', label: 'View Cane Creek Air IL Service' },
    'cane creek db coil': { url: '/pages/cane-creek-dbcoil', label: 'View Cane Creek DBcoil Service' },
    'cane creek db coil il': { url: '/pages/cane-creek-coil-il', label: 'View Cane Creek Coil IL Service' }
  };

  var groupedCardLinks = {
    'fox 32, 34 & 34 sl': [
      { label: 'Fox 32', url: '/pages/fox-32' },
      { label: 'Fox 34 / 34 SL', url: '/pages/fox-34' }
    ],
    'fox 36 & 36 sl': [
      { label: 'Fox 36 / 36 SL', url: '/pages/fox-36' }
    ],
    'fox float sl, dps, ctd & rp23': [
      { label: 'Float SL', url: '/pages/fox-float-sl' },
      { label: 'Float DPS', url: '/pages/fox-float-dps' },
      { label: 'Float CTD', url: '/pages/fox-float-ctd' },
      { label: 'Float RP-Series', url: '/pages/fox-float-rp-series' }
    ],
    'fox dpx2 & float x': [
      { label: 'DPX2', url: '/pages/fox-dpx2' },
      { label: 'Float X', url: '/pages/fox-float-x' }
    ],
    'fox dhx & dhx2': [
      { label: 'Fox DHX', url: '/pages/fox-dhx' },
      { label: 'Fox DHX2', url: '/pages/fox-dhx2' }
    ],
    'fox van r, van rc & dhx rc4': [
      { label: 'VAN R / RC', url: '/pages/fox-van-r-rc' },
      { label: 'DHX RC4 / RC2', url: '/pages/fox-dhx-rc4-rc2' }
    ],
    'rockshox super deluxe': [
      { label: 'Super Deluxe Air', url: '/pages/rockshox-super-deluxe' },
      { label: 'Super Deluxe Coil', url: '/pages/rockshox-super-deluxe-coil' }
    ],
    'rockshox vivid': [
      { label: 'Vivid Air', url: '/pages/rockshox-vivid-air' },
      { label: 'Vivid Coil', url: '/pages/rockshox-vivid-coil' }
    ],
    'rockshox monarch': [
      { label: 'Monarch', url: '/pages/rockshox-monarch' },
      { label: 'Monarch Plus', url: '/pages/rockshox-monarch-plus' }
    ],
    'öhlins ttx air': [
      { label: 'TTX1Air', url: '/pages/ohlins-ttx1air' },
      { label: 'TTX2Air', url: '/pages/ohlins-ttx2air' }
    ],
    'öhlins ttx coil & ttx22m': [
      { label: 'TTX22M / TTX22M.2', url: '/pages/ohlins-ttx22m' }
    ]
  };

  function brandKeyFromName(value) {
    var name = normalise(value);

    if (name === 'fox' || name === 'fox suspension') {
      return 'fox';
    }

    if (name === 'rockshox') {
      return 'rockshox';
    }

    if (name === 'öhlins' || name === 'ohlins') {
      return 'ohlins';
    }

    if (name === 'marzocchi') {
      return 'marzocchi';
    }

    if (name === 'dvo') {
      return 'dvo';
    }

    if (name === 'cane creek') {
      return 'canecreek';
    }

    return '';
  }

  function addStyles() {
    if (document.getElementById('cjs-model-link-styles')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'cjs-model-link-styles';
    style.textContent =
      '.cjs-brands-hub__model-list li.is-linked{padding:0;overflow:hidden;}' +
      '.cjs-brands-hub__model-list li.is-linked>a{display:block;padding:7px 10px;color:inherit;text-decoration:none;border-radius:999px;}' +
      '.cjs-brands-hub__model-list li.is-linked>a:hover{color:var(--cjs-accent);background:rgba(168,50,58,.07);}' +
      '.cjs-model-direct-links{display:flex;flex-wrap:wrap;gap:7px;margin:16px 0 3px;}' +
      '.cjs-model-direct-links a{display:inline-flex;align-items:center;padding:7px 10px;border:1px solid var(--cjs-border,#e6e2dd);border-radius:999px;color:var(--cjs-accent,#a8323a);background:#fff;font-size:12px;font-weight:800;line-height:1.2;text-decoration:none;}' +
      '.cjs-model-direct-links a:hover{border-color:var(--cjs-accent,#a8323a);}' +
      '.cjs-brands-menu__models li[data-cjs-split-model]{margin:0;}';

    document.head.appendChild(style);
  }

  function ensureRequiredHubModels(card, brand) {
    var list = card.querySelector('.cjs-brands-hub__model-list');
    var required = requiredHubModels[brand] || [];

    if (!list || !required.length) {
      return;
    }

    var existing = Array.prototype.slice.call(list.querySelectorAll('li')).map(function (item) {
      return normalise(item.textContent);
    });

    required.forEach(function (entry) {
      if (existing.indexOf(normalise(entry.label)) !== -1) {
        return;
      }

      var item = document.createElement('li');
      var link = document.createElement('a');

      item.className = 'is-linked';
      item.setAttribute('data-cjs-added-model-chip', '');
      link.href = entry.url;
      link.textContent = entry.label;
      link.setAttribute('data-cjs-model-link', '');

      item.appendChild(link);
      list.appendChild(item);
      existing.push(normalise(entry.label));
    });
  }

  function wireBrandsHub() {
    var cards = document.querySelectorAll('.cjs-brands-hub__brand-card');

    cards.forEach(function (card) {
      var heading = card.querySelector('h3');
      var brand = brandKeyFromName(heading ? heading.textContent : '');

      if (!brand) {
        return;
      }

      ensureRequiredHubModels(card, brand);

      var hubUrl = brandHubUrls[brand];
      var cardLink = card.querySelector('.cjs-brands-hub__card-link');
      if (hubUrl && cardLink) {
        cardLink.href = hubUrl;
      }

      var items = card.querySelectorAll('.cjs-brands-hub__model-list li');
      items.forEach(function (item) {
        if (item.classList.contains('is-linked')) {
          return;
        }

        var label = normalise(item.textContent);
        var urls = modelUrls[brand] || {};
        var url = urls[stripBrand(label, brand)];

        if (!url) {
          return;
        }

        var link = document.createElement('a');
        link.href = url;
        link.textContent = item.textContent.trim();
        link.setAttribute('data-cjs-model-link', '');

        item.textContent = '';
        item.appendChild(link);
        item.classList.add('is-linked');
      });
    });
  }

  function splitMegaMenuItem(item, entries) {
    if (!item || !item.parentNode || !entries || !entries.length) {
      return;
    }

    entries.forEach(function (entry) {
      var newItem = document.createElement('li');
      var link = document.createElement('a');

      newItem.setAttribute('data-cjs-split-model', '');
      link.href = entry.url;
      link.textContent = entry.label;
      newItem.appendChild(link);
      item.parentNode.insertBefore(newItem, item);
    });

    item.parentNode.removeChild(item);
  }

  function wireMegaMenu() {
    var brands = document.querySelectorAll('.cjs-brands-menu__brand');

    brands.forEach(function (card) {
      var brandName = card.querySelector('.cjs-brands-menu__brand-name');
      var brand = brandKeyFromName(brandName ? brandName.textContent : '');

      if (!brand) {
        return;
      }

      var links = Array.prototype.slice.call(card.querySelectorAll('.cjs-brands-menu__models a'));
      links.forEach(function (link) {
        var item = link.closest('li');
        var modelName = stripBrand(link.textContent, brand);
        var groups = megaMenuGroups[brand] || {};
        var group = groups[modelName];

        if (group && item && !item.hasAttribute('data-cjs-split-model')) {
          splitMegaMenuItem(item, group);
          return;
        }

        var urls = modelUrls[brand] || {};
        var url = urls[modelName];
        if (url) {
          link.href = url;
          link.setAttribute('data-cjs-model-link', '');
        }
      });
    });
  }

  function addGroupedCardLinks(card, links) {
    if (!card || card.querySelector('[data-cjs-model-direct-links]')) {
      return;
    }

    var cardLink = card.querySelector('.cjs-brand-page__card-link');
    var content = card.querySelector('.cjs-brand-page__product-content');

    if (!content || !links || !links.length) {
      return;
    }

    var row = document.createElement('div');
    row.className = 'cjs-model-direct-links';
    row.setAttribute('data-cjs-model-direct-links', '');

    links.forEach(function (entry) {
      var link = document.createElement('a');
      link.href = entry.url;
      link.textContent = entry.label;
      row.appendChild(link);
    });

    if (cardLink) {
      content.insertBefore(row, cardLink);
    } else {
      content.appendChild(row);
    }
  }

  function wireBrandSupportCards() {
    var cards = document.querySelectorAll('.cjs-brand-page__product-card');

    cards.forEach(function (card) {
      var heading = card.querySelector('h3');
      var key = normalise(heading ? heading.textContent : '');
      var single = singleCardLinks[key];
      var grouped = groupedCardLinks[key];

      if (single) {
        var cardLink = card.querySelector('.cjs-brand-page__card-link');
        if (!cardLink) {
          return;
        }

        cardLink.href = single.url;
        cardLink.setAttribute('data-cjs-model-link', '');

        var label = cardLink.querySelector('span:first-child');
        if (label && label.textContent !== single.label) {
          label.textContent = single.label;
        }
      } else if (grouped) {
        addGroupedCardLinks(card, grouped);
      }
    });
  }

  function wireAll() {
    addStyles();
    wireBrandsHub();
    wireMegaMenu();
    wireBrandSupportCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }

  var observer = new MutationObserver(function () {
    observer.disconnect();
    wireAll();
    startObserver();
  });

  function startObserver() {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  startObserver();
})();

/* CJSUSPENSION service route safety
 * Keeps legacy/fallback service-menu URLs pointing at current live pages.
 */
(function () {
  'use strict';

  var routeMap = {
    '/pages/suspension-services': '/pages/mtb-suspension-services',
    '/pages/motocross-suspension-servicing': '/pages/moto-service-info',
    '/pages/service-pricing': '/pages/book-a-suspension-service'
  };

  function fixServiceRoutes() {
    var links = document.querySelectorAll('a[href]');

    links.forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var replacement = routeMap[href];

      if (replacement) {
        link.setAttribute('href', replacement);
        link.setAttribute('data-cjs-service-route-fixed', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixServiceRoutes);
  } else {
    fixServiceRoutes();
  }

  var observer = new MutationObserver(function () {
    fixServiceRoutes();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
